import { Link } from '@tanstack/router'

import useDimensions from '../../hooks/useDimensions'
import classNames from '../../utils/classNames'
import Icon from '../icon'
interface PlatformProps {
  link?: string
  label: string
  note?: string
  onClick?: () => void
  active?: boolean
  icon: string
  route: 'deposit' | 'withdraw'
}

const Platform = ({
  link,
  label,
  active,
  onClick,
  icon,
  note,
  route,
}: PlatformProps) => {
  const { isDesktop } = useDimensions()

  return (
    <Link
      to={!isDesktop ? `/${route}/$id` : undefined}
      params={{ id: link ?? '' }}>
      <div
        className={classNames(
          'flx-btw-ctr h-[60px] lg:h-[70px] lg:-mr-[1px] mb-3 px-4 lg:px-5 transition-all duration-200 ease-in-out',
          active && isDesktop ? 'bg-[#e0e0ec] dark:bg-primary' : 'bg-tertiary',
        )}
        onClick={onClick}>
        <div className="flx-ctr">
          <img src={icon} alt="Alipay" className="w-[25px] lg:w-[30px] h-[25px] lg:h-[30px] mr-5"/>
          <span className="text-sm lg:text-lg text-txt font-Avenir-Light">{label}</span>
        </div>
        {note && <span className="text-xs text-[#999999] font-Avenir-Light mx-5">{note}</span>}
        <Icon id="chevron-right" width="10" className="fill-txt"/>
      </div>
    </Link>
  )
}

export default Platform
